<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <div class="ui segment">
      <div class="centered-header">
        <h2 class="ui header" style="color: #092442;">
          <i class="dollar sign icon"></i>
          <div class="content">
            Invoice # {{ displaySystemCode(invoice.system_number) }}
          </div>
        </h2>
      </div>

      <!-- <br/> -->

      <h4 class="ui dividing header">
        Basic Infromation
      </h4>
      <abstractTable :data="invoiceInfo"
                     :definitionTable="true"
                     :definitionTableWidth="'20%'"
                     :classes="'ui compact definition table'">
      </abstractTable>

      <br/>
      <div class="ui two columns grid">
        <div class="column">
          <h4 class="ui dividing header">
            Company Infromation
          </h4>
          <abstractTable :data="companyInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'35%'"
                         :classes="'ui compact definition table'">
          </abstractTable>
        </div>

        <div class="column">
          <h4 class="ui dividing header">
            Users Infromation
          </h4>
          <abstractTable :data="usersInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'30%'"
                         :classes="'ui compact definition table'">
          </abstractTable>
        </div>
      </div>

      <br/>

      <h4 class="ui dividing header">
        Invoice Details
      </h4>

      <abstractTable :columns="invoiceEntriesColumns" :data="computedInvoiceEntries"
                     :classes="'ui tablet very compact center aligned celled table'"
                     :hasFooter="true" v-if="computedInvoiceEntries.length">

        <template slot="footer" slot-scope="props">
          <th colspan="5"> Total Price</th>
          <th colspan="1">
            {{ getInvoiceTotalPrice }}
          </th>
        </template>
      </abstractTable>

      <h4 class="ui dividing header">
        Invoice Transaction
      </h4>

      <transactions
        :invoiceId="invoice.id"
        :transactions="invoice.transactions"
      />

    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    transactions: require('@/components/inventory_system/invoices/invoice_components/TransactionsPart').default
  },
  data () {
    return {
      invoice: {},
      branch: {},
      company: {},
      telephones: [],
      invoiceTotalPrice: 0,
      loading: true
    }
  },
  mounted () {
    this.$http.get(`invoices/${this.$route.params.id}`, {
      params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      }
    }).then(response => {
      this.invoice = response.data.invoice
      this.branch = response.data.meta.branch
      this.company = response.data.meta.company
      this.telephones = response.data.meta.telephones
      this.loading = false
    })
  },
  computed: {
    invoiceInfo () {
      return {
        id: this.invoice.id,
        invoice_type: this.invoice.invoice_type.name,
        real_number: this.invoice.real_number || '-',
        system_number: this.displaySystemCode(this.invoice.system_number),
        date: window.moment(this.invoice.date).format('DD/MM/YYYY hh:mm a'),
        notes: this.invoice.notes || '-'
      }
    },
    companyInfo () {
      return {
        company: this.company.name,
        branch: this.branch.address,
        company_employee_name: this.invoice.company_employee_name || '-',
        telephones: {
          html: true,
          value: this.getTelephones
        }
      }
    },
    usersInfo () {
      return {
        creator_user: this.invoice.creator.name,
        recipient_user: this.invoice.recipient.name
      }
    },
    getTelephones () {
      let telephones = ''
      window._.each(this.telephones, telephoneObject => {
        telephones +=
          '<strong>' + telephoneObject.telephone_type.name + ':</strong> ' + telephoneObject.telephone.number + '.<br/>'
      })

      return telephones !== '' ? telephones : '-'
    },
    invoiceEntriesColumns () {
      return [
        { header: 'Item', fieldName: 'itemName', show: true, html: true },
        { header: 'Unit Price', fieldName: 'unitPrice', show: true },
        { header: 'Quantity', fieldName: 'quantity', show: true },
        { header: 'Total Price', fieldName: 'totalPrice', show: true },
        { header: 'Label', fieldName: 'label', show: true },
        { header: 'Expire at', fieldName: 'expired_at', show: true }
      ]
    },
    computedInvoiceEntries () {
      let formlatedInvoiceEnttries = []

      window._.each(this.invoice.invoice_entries, (invoiceEntry, index) => {
        this.invoiceTotalPrice +=
          Number(invoiceEntry.unit_price) * Number(invoiceEntry.quantity)
        formlatedInvoiceEnttries.push({
          itemName: {
            functionality: () => {
              this.navigateTo('Show_Item', { key: 'params', value: { id: invoiceEntry.item.id } })
            },
            value: `<a style="cursor: pointer; text-decoration:underline;">${invoiceEntry.item.name}</a>`
          },
          unitPrice: invoiceEntry.unit_price.toLocaleString() + ' E£',
          quantity: invoiceEntry.quantity,
          totalPrice:
            (Number(invoiceEntry.unit_price) * Number(invoiceEntry.quantity)).toLocaleString() + ' E£',
          label: invoiceEntry.label || '-',
          expired_at: invoiceEntry.expired_at ? 
            window.moment(invoiceEntry.expired_at).format('YYYY-MM-DD') : '-'
        })
      })

      return formlatedInvoiceEnttries
    },
    getInvoiceTotalPrice () {
      return this.invoiceTotalPrice.toLocaleString() + ' E£'
    }
  },
  methods: {
    displaySystemCode (code) {
      if (code.length < 8) {
        return '0'.repeat(8 - code.length) + code
      }

      return code
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
  .virtical-center {
    display: flex !important;
    align-items: center !important;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/inventory_system/invoices/Invoice.vue